<template>
  <div class="row mb-10">
    <div class="col-sm-6 col-md-4 d-flex align-center">
      <EducationSystemSelect
        @setEducationSystem="parameters.education_system_id = $event"
      />
    </div>
    <div class="col-sm-6 col-md-4 d-flex align-center">
      <EducationStageSelect
        :education-system-id="parameters.education_system_id"
        @setEducationStage="parameters.education_stage_id = $event"
      />
    </div>
    <div class="col-sm-6 col-md-4 d-flex align-center">
      <GradeSelect
        :education-stage-id="parameters.education_stage_id"
        @setGrade="parameters.grade_id = $event"
      />
    </div>

    <div class="d-flex flex-fill justify-end">
      <v-btn
        :disabled="hasParameters"
        depressed
        class="float-right"
        @click="setParameters()"
      >
        <v-icon left>
          mdi-magnify
        </v-icon>
        Aplicar filtros
      </v-btn>
    </div>
  </div>
</template>

<script>
import EducationSystemSelect from '@/components/contents/EducationSystemSelect.vue'
import EducationStageSelect from '@/components/contents/EducationStageSelect.vue'
import GradeSelect from '@/components/contents/GradeSelect.vue'

export default {
  components: {
    EducationSystemSelect,
    EducationStageSelect,
    GradeSelect
  },

  data: () => ({
    parameters: {
      education_system_id: null,
      education_stage_id: null,
      grade_id: null
    }
  }),
  watch: {
  },
  computed: {
    hasParameters () {
      return Object.entries(this.parameters).filter(([_, value]) => value !== null).length === 0
    }
  },

  created () {
  },

  methods: {

    setParameters () {
      const parameters = this.buildQuery()
      this.$emit('setParameters', parameters)
    },

    buildQuery () {
      return Object.entries(this.parameters)
        .filter(([_, value]) => value !== null)
        .map(([key, value]) => {
          const normalizedValue =
            value === true ? 1 : value === false ? 0 : value

          return `&${encodeURIComponent(key)}=${encodeURIComponent(normalizedValue)}`
        })
        .join('')
    }
  }
}
</script>
